import React, {useEffect, useState} from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import {Loading} from "../../index";
import Button from "@mui/material/Button";
import Api from "../../../utils/api";
import DialogActions from "@mui/material/DialogActions";
import AccumulativeExcelDownload from "./excel";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DialogTitle from "@mui/material/DialogTitle";

const Accumulative = (props) => {

    const { id, depot, onComplete } = props;

    const [open, setOpen] = useState(false);
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        if (open) {
            setLoading(true);
            new Api().put('/depot/' + id + '/accumulative').then((response) => {
                if (typeof response !== "undefined") {
                    setList(response);
                    onComplete();
                }

                setLoading(false);
            })
        }
    }, [open]);


    return(

        <React.Fragment>
            <Button style={{ marginBottom: 5}} onClick={() => setOpen(true)} size={"small"} variant={"outlined"}>گزارش تجمیعی</Button>
            <Dialog
                fullScreen={true}
                open={open}
                keepMounted
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <AppBar>
                    <Toolbar className='display-flex display-flex-justify-content-space-between'>
                        <Typography variant={"button"} >
                            {'گزارش از فاکتورهای' + ' ' + depot.from_order + ' تا ' + depot.to_order + ' به تعداد ' + depot.count}
                        </Typography>
                        <IconButton edge="start" color="inherit" onClick={() => setOpen(false)} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <DialogTitle id="form-dialog-title">گزارش تجمیعی</DialogTitle>
                <DialogContent>
                    <div style={{ overflowX: 'auto'}}>
                        <table style={{ margin: 0 }} className='table-duplicate-row'>
                            <thead>
                            <tr>
                                <th>ردیف</th>
                                <th>محصول</th>
                                <th>کد انبار</th>
                                <th>برند</th>
                                <th>تعداد</th>
                            </tr>
                            </thead>
                            <tbody>
                            {list && list.map((item, index) => {
                                return(
                                    <tr>
                                        <td>{index + 1}</td>
                                        <td><b>{item.product_title}</b></td>
                                        <td>{item.code}</td>
                                        <td>{item.brand_title}</td>
                                        <td>{item.counter}</td>
                                    </tr>
                                );
                            })}
                            </tbody>
                        </table>
                    </div>
                    {loading && <Loading />}
                </DialogContent>
                <DialogActions>
                    <AccumulativeExcelDownload name={ depot.from_order + '_' + depot.to_order + '_' + depot.count} data={list} />
                    {/*<AccumulativePrint name={ depot.from_order + '_' + depot.to_order + '_' + depot.count} data={list} />*/}
                    <Button onClick={() => setOpen(false)}>
                        بستن
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

export default Accumulative;